import type {PublicMethodUtils} from '@wix/document-services-types'
import type {SlotsPublicAPI} from '@wix/document-services-public-types'
import {slots} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<SlotsPublicAPI> {
    return {
        methods: {
            components: {
                slots: {
                    populate: publicMethodUtils.defineDataManipulationAction(slots.populate, {
                        getReturnValue: slots.getComponentToAddPointer
                    }),
                    moveToSlot: publicMethodUtils.defineDataManipulationAction(slots.moveToSlot),
                    remove: publicMethodUtils.defineDataManipulationAction(slots.remove),
                    getSlotNames: publicMethodUtils.defineGetter(slots.getSlotNames),
                    getSlotsData: publicMethodUtils.defineGetter(slots.getSlotsData),
                    getWidgetSlots: publicMethodUtils.defineGetter(slots.getWidgetSlots),
                    getOwnerOfComponentInSlot: publicMethodUtils.defineGetter(slots.getOwnerOfComponentInSlot),
                    isChildOfSlottedComp: publicMethodUtils.defineGetter(slots.isChildOfSlottedComp),
                    builder: {
                        getWidgetSlots: publicMethodUtils.defineGetter(slots.getBuilderWidgetSlots),
                        getSlottedComponentOwner: publicMethodUtils.defineGetter(slots.getBuilderSlottedComponentOwner),
                        getPopulatedComponentContainerInfoMap: publicMethodUtils.defineGetter(
                            slots.getPopulatedComponentContainerInfoMap
                        )
                    }
                }
            }
        }
    }
}
